import Swal from 'sweetalert2';

let modalOpen = false;

function toast(type, title, position = 'bottom-end', cancel = '', confirm = '', callback = () => {}, timer = 10000) {
  if (modalOpen) return;

  Swal.fire({
    position,
    toast: true,
    timer: timer,
    showCloseButton: true,
    cancelButtonText: cancel,
    confirmButtonText: confirm,
    showCancelButton: Boolean(cancel),
    showConfirmButton: Boolean(confirm),
    html: `
      <div class="bdk-preflight bdk-p-4 bdk-flex">
        <div class="swal2-symbol" style="background-color: var(--${type})"></div>
        <p class="bdk-text-sm bdk-font-medium bdk-text-gray-900">
          ${title}
        </p>
      </div>
    `,
    customClass: {
      popup: 'bdk-max-w-sm bdk-w-full bdk-shadow-lg bdk-rounded-lg bdk-pointer-events-auto bdk-ring-1 bdk-ring-black bdk-ring-opacity-5 bdk-overflow-hidden',
      confirmButton: 'bdk-preflight bdk-bg-white bdk-ml-8 bdk-rounded-md bdk-text-sm bdk-font-medium bdk-text-indigo-600 hover:bdk-text-indigo-500 focus:bdk-outline-none focus:bdk-ring-2 focus:bdk-ring-offset-2 focus:bdk-ring-indigo-500',
      cancelButton: 'bdk-preflight bdk-bg-white bdk-rounded-md bdk-text-sm bdk-font-medium bdk-text-gray-700 hover:bdk-text-gray-500 focus:bdk-outline-none focus:bdk-ring-2 focus:bdk-ring-offset-2 focus:bdk-ring-indigo-500',
    },
  }).then(callback);
}

export const Alert = {
  success: (title, position) => toast('success', title, position),
  error: (title, position) => toast('danger', title, position),
  warning: (title, position) => toast('warning', title, position),
  info: (title, position) => toast('info', title, position),
  question: (title, position) => toast('question', title, position),
  message: (type, title, position, cancel, confirm, call, timer = 10000) => toast(type, title, position, cancel, confirm, call, timer),
  close: () => Swal.close(),

  setModalOpen: (status) => {
    modalOpen = status;
  }
};
